import { Styles } from "@mcleod/core";

export const RadioOptionStyles = Styles.make("rdo", () => {
    return {
        optionBase: {
            display: "flex",
            alignItems: "center",
            userSelect: "none"
        }
    };
});
